(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function initFaqs(root) {
    var items = toArray(root.querySelectorAll('[data-sau-faq]'));
    var single = root.getAttribute('data-single') === 'true';
    if (!single || items.length === 0) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function showAll(nodes) {
    nodes.forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function initReveal(root) {
    var nodes = toArray(root.querySelectorAll('[data-sau-reveal]'));
    if (!nodes.length) return;

    if (root.getAttribute('data-reveal') !== 'true') {
      showAll(nodes);
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      showAll(nodes);
      return;
    }

    // Arm only after JS is ready so content never stays invisible without script
    root.classList.add('sau--armed');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    nodes.forEach(function (el) {
      io.observe(el);
    });

    // Safety: if nothing revealed after short time, show everything
    window.setTimeout(function () {
      nodes.forEach(function (el) {
        if (!el.classList.contains('is-in')) el.classList.add('is-in');
      });
    }, 2500);
  }

  function init(root) {
    if (!root || root.getAttribute('data-sau-ready') === 'true') return;
    root.setAttribute('data-sau-ready', 'true');
    initFaqs(root);
    initReveal(root);
  }

  function boot() {
    toArray(document.querySelectorAll('[data-sau]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-sau]')).forEach(function (el) {
      el.removeAttribute('data-sau-ready');
      el.classList.remove('sau--armed');
      init(el);
    });
  });
})();
